import { render, staticRenderFns } from "./HumanBody.vue?vue&type=template&id=32ce3c4f&scoped=true&"
import script from "./HumanBody.vue?vue&type=script&lang=js&"
export * from "./HumanBody.vue?vue&type=script&lang=js&"
import style0 from "./HumanBody.vue?vue&type=style&index=0&id=32ce3c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce3c4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
